import React, { Component }  from 'react';
import { Routes } from './config';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import './styles/style.css'
import './styles/demo.css'
import './styles/custom.css'
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
function App() {
  return (
    <div>
    <Routes/>
    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js